<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="row white-bg">
        <div class="col-md-12 col-xs-12 col-sm-12 text-center">
          <h4 class="mt-3"><b>ยอดขายรายคน <i class="far fa-poll-people"></i></b></h4>
          <div class="row mt-2 mr-2 ml-2">
            <div class="col-md-2 col-xs-2 col-sm-2 mb-2">
              <h5><b>ช่วงเวลาวันที่:&nbsp;</b></h5>
            </div>
            <div class="col-md-4 col-xs-4 col-sm-4 mb-2">
              <v-date-picker mode='range' v-model='picker' :input-props='{ class:"pull-right text-center form-control",style:"background: #fff; cursor: pointer; padding: 5px 10px; border: 1px solid #ccc; width: 100%", placeholder: "กรุณาเลือกช่วงเวลาของยอดขายที่ต้องการทราบ", readonly: true }'
              show-caps></v-date-picker>
            </div>
            <div class="col-md-3 col-xs-3 col-sm-3 mb-2">
              <button type="button" class="btn btn-primary form-control" v-on:click="setAPI()">
                ตรวจสอบ <i class="fas fa-search"></i>
              </button>
            </div>
            <div class="col-md-3 col-xs-3 col-sm-3 mb-2">
              <button type="button" class="btn btn-primary form-control" v-on:click="exportFromExcel()">
                ดาวน์โหลด XLSX <i class="far fa-download"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-xs-12 col-sm-12 text-center">
          <div class="panel panel-default">
            <vue-bootstrap4-table :rows="table.rows" :columns="table.columns" @refresh-data="sendAPI" :config="table.config"></vue-bootstrap4-table>
          </div>
        </div>
      </div>
    </div>
    <Loading :percent="load.percent" :active="load.active"></Loading>
  </div>
</template>
<script>
import Vue from 'vue';
import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';
import Number from '../../utils/Number.js';
import JWT from '../../utils/JWT.js';
import XLSX from 'xlsx';
Vue.use(VCalendar);
export default {
  components: {
    'VueBootstrap4Table': () => import('vue-bootstrap4-table'),
    'Loading': () => import('../../utils/Loading.vue')
  },
  data() {
    return {
      picker: {
        start: this.$moment().toDate(),
        end: this.$moment().toDate()
      },
      data: {
        date: {
          start: '',
          end: ''
        }
      },
      alert: {
        message: ''
      },
      load: {
        task: 0,
        count: 0,
        percent: 0,
        active: false
      },
      table: {
        rows: [],
        config: {
          per_page: 25,
          per_page_options: [25,50,75,100],
          global_search: {
            placeholder: "ค้นหา...",
          }
        },
        columns: [{
          label: "รหัสมินิ",
          name: "mini_code",
          sort: true
        },{
          label: "ชื่อมินิ",
          name: "mini_name",
          sort: true
        },{
          label: "รหัสวอลล์แมน",
          name: "wm_code",
          sort: true,
          initial_sort: true,
          initial_sort_order: "desc"
        }, {
          label: "ชื่อ-นามสกุล",
          name: "full_name",
          sort: true
        },{
          label: "รหัสบาร์โค้ดรถ",
          name: "bike_barcode",
          sort: true
        }, {
          label: "ทะเบียนรถ",
          name: "plate_no",
          sort: true
        },{
          label: "ยอดขาย",
          name: "sale",
          sort: true
        }, {
          label: "ภาษี(บาท)",
          name: "vat",
          sort: true
        }, {
          label: "ยอดขายสุทธิ",
          name: "total",
          sort: true
        }, {
          label: "สถานะ",
          name: "wm_status",
          sort: true
        }
        ]
      }
    }
  },
  mounted() {
  },
  methods: {
    resetLoading(task) {
      this.load.count = 0
      this.load.task = task
      this.load.percent = 0
      this.load.active = true
    },
    setAPI(){
      this.data.date = {
        'start': this.$moment(this.picker.start).format('YYYY-MM-DD'),
        'end': this.$moment(this.picker.end).format('YYYY-MM-DD')
      }
      this.sendAPI()
    },
    async sendAPI() {
      try {
        await this.resetLoading(1)
        const res = (await this.$http.get(process.env.VUE_APP_AUTH_URL + 'api/v1/user/wallsman/export/sales/' +
          await JWT.encode({
            start: this.data.date.start,
            end: this.data.date.end
          }))).body
        let value=null, data =[];
        for(value of res['data']){
          data.push({bike_barcode: value.bike_barcode,
            full_name: value.full_name,
            mini_code: value.mini_code,
            mini_name: value.mini_name,
            plate_no: value.plate_no,
            total: value.total,
            sale: await Number.formatMoney(await Number.toFixed((value.total * 100 / 107), 2), 2, ".", ","),
            vat: await Number.formatMoney(await Number.toFixed((value.total * 7/107), 2), 2, ".", ","),
            total: await Number.formatMoney(await Number.toFixed(value.total, 2), 2, ".", ","),
            wm_code: value.wm_code,
            wm_status: value.wm_status});
        }
        this.table.rows=data
        this.load.active = false
      } catch (error) {
        this.load.active = false
        if (error.body) {
          if (error.body.alert) {
            this.alert.message = error.body.alert
          } else {
            this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
          }
        } else {
          this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
        }
        this.$dialogs.alert(this.alert.message,{title: 'เกิดข้อผิดพลาดในการดึงข้อมูล'})
      }
    },
    async exportFromExcel() {
      if (this.table.rows.length > 0) {
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, await XLSX.utils.json_to_sheet(this.table.rows), 'WallsMan Sales')
        XLSX.writeFile(wb, 'wallsman_sales(' + await this.$moment().format('YYYY-MM-DD-H-mm-ss') + ')_Start-' + await this.$moment(this.picker.start).format('YYYY-MM-DD') + '_End-' + await this.$moment(
          this.picker.end).format('YYYY-MM-DD') + '.xlsx')
        this.$notify({
          title: 'Export Excel',
          text: 'Export Excel WallsMan Sales Succeed!'
        });
      }
    }
  }
}

</script>
